export const CITIES = [
  {
    slug: 'paris',
    name: 'Paris',
    country: 'FR',
    region: 'Île-de-France',
    intro:
      "Paris concentre les plus belles salles de réception, les grands clubs et les sièges d'entreprise qui cherchent une animation mémorable. Nos kits de bracelets LED sont livrés prêts à l'emploi partout dans la capitale et en Île-de-France.",
    venues: ['salles de réception du Marais et de la rive gauche', 'clubs et rooftops parisiens', 'salons et congrès Porte de Versailles', 'soirées d\'entreprise à La Défense'],
  },
  {
    slug: 'lyon',
    name: 'Lyon',
    country: 'FR',
    region: 'Auvergne-Rhône-Alpes',
    intro:
      "De la Presqu'île aux domaines des Monts d'Or, Lyon reçoit toute l'année mariages, galas et soirées étudiantes. Nous livrons vos bracelets LED synchronisés dans tout le Rhône.",
    venues: ['domaines de mariage des Monts d\'Or', 'clubs de la Presqu\'île', 'événements d\'entreprise à la Part-Dieu', 'festivals de la métropole'],
  },
  {
    slug: 'marseille',
    name: 'Marseille',
    country: 'FR',
    region: 'Provence-Alpes-Côte d\'Azur',
    intro:
      "Soirées en bord de mer, mariages en bastide, concerts en plein air : à Marseille, l'effet d'une foule entière qui s'illumine se voit de loin. Livraison dans toutes les Bouches-du-Rhône.",
    venues: ['bastides et domaines provençaux', 'plages privées et beach clubs', 'salles de concert du Vieux-Port', 'événements sportifs et clubs de sport'],
  },
  {
    slug: 'bordeaux',
    name: 'Bordeaux',
    country: 'FR',
    region: 'Nouvelle-Aquitaine',
    intro:
      "Châteaux viticoles, quais et grandes salles : Bordeaux est une ville d'événements haut de gamme, où une animation lumineuse fait la différence sur les photos comme dans les souvenirs.",
    venues: ['châteaux et domaines viticoles', 'mariages du Médoc et de Saint-Émilion', 'soirées d\'entreprise à Bordeaux Lac', 'clubs et bars des quais'],
  },
  {
    slug: 'lille',
    name: 'Lille',
    country: 'FR',
    region: 'Hauts-de-France',
    intro:
      "Lille et sa métropole vivent au rythme des soirées étudiantes, des braderies et des grands événements d'entreprise. Nos kits arrivent prêts à distribuer, sans installation.",
    venues: ['soirées étudiantes et BDE', 'salles de réception de la métropole', 'concerts au Zénith et à l\'Aéronef', 'galas et congrès à Euralille'],
  },
  {
    slug: 'toulouse',
    name: 'Toulouse',
    country: 'FR',
    region: 'Occitanie',
    intro:
      "Mariages en Haute-Garonne, soirées aéronautiques, festivals d'été : Toulouse aime les grandes réunions. Vos bracelets LED se synchronisent seuls, dès la première seconde.",
    venues: ['domaines de mariage de la Haute-Garonne', 'soirées d\'entreprise du secteur aéronautique', 'festivals et fêtes de village', 'clubs du centre-ville'],
  },
  {
    slug: 'nice',
    name: 'Nice',
    country: 'FR',
    region: 'Côte d\'Azur',
    intro:
      "Sur la Côte d'Azur, l'événementiel se joue sur le spectacle. Une foule entière qui change de couleur en même temps, c'est l'image que vos invités partageront le soir même.",
    venues: ['villas et hôtels de la Côte d\'Azur', 'plages privées de Nice et Cannes', 'congrès et lancements de marque', 'clubs et soirées yachting'],
  },
  {
    slug: 'nantes',
    name: 'Nantes',
    country: 'FR',
    region: 'Pays de la Loire',
    intro:
      "Nantes et son bassin d'événements culturels, ses mariages en bord de Loire et ses grandes soirées associatives : nos kits s'adaptent de 50 à 1 000 personnes.",
    venues: ['châteaux et domaines en bord de Loire', 'salles associatives et municipales', 'concerts et scènes nantaises', 'soirées d\'entreprise à l\'Île de Nantes'],
  },
  {
    slug: 'strasbourg',
    name: 'Strasbourg',
    country: 'FR',
    region: 'Grand Est',
    intro:
      "Capitale européenne, Strasbourg vit au rythme des congrès internationaux, des soirées étudiantes et des grands événements de fin d'année. Nos kits de bracelets LED synchronisés sont livrés prêts à l'emploi dans tout le Bas-Rhin.",
    venues: ['congrès et institutions européennes', 'soirées étudiantes de la Krutenau', 'salles de réception et domaines alsaciens', 'événements de fin d\'année et marchés de Noël'],
  },
  {
    slug: 'montpellier',
    name: 'Montpellier',
    country: 'FR',
    region: 'Occitanie',
    intro:
      "Entre Méditerranée et vie étudiante, Montpellier multiplie les soirées, mariages en domaine et événements d'été. Nos bracelets LED synchronisés illuminent vos invités de 50 à 1 000 personnes.",
    venues: ['domaines de mariage dans l\'Hérault', 'beach clubs et plages du littoral', 'soirées étudiantes et BDE', 'salons et congrès au Corum'],
  },
  {
    slug: 'rennes',
    name: 'Rennes',
    country: 'FR',
    region: 'Bretagne',
    intro:
      "Ville étudiante et terre de festivals comme les Transmusicales, Rennes aime les grandes réunions. Nos kits de bracelets LED se synchronisent seuls pour transformer vos soirées en spectacle.",
    venues: ['soirées étudiantes et galas', 'festivals et concerts', 'salles de réception de la métropole', 'événements d\'entreprise à la Courrouze'],
  },
  {
    slug: 'grenoble',
    name: 'Grenoble',
    country: 'FR',
    region: 'Auvergne-Rhône-Alpes',
    intro:
      "Au pied des montagnes, Grenoble réunit événements d'entreprise tech, soirées étudiantes et réceptions en station. Nos bracelets LED synchronisés apportent une dimension lumineuse à chaque moment.",
    venues: ['événements d\'entreprise et tech de la presqu\'île scientifique', 'soirées en station de ski', 'soirées étudiantes et galas', 'salles de réception et domaines iséroises'],
  },
  {
    slug: 'dubai',
    name: 'Dubaï',
    country: 'AE',
    region: 'Émirats arabes unis',
    intro:
      "Dubaï est la capitale mondiale de l'événementiel haut de gamme : mariages de luxe, galas d'entreprise, soirées sur rooftops et réceptions dans les plus grands hôtels. Nos kits de bracelets LED synchronisés y sont distribués par notre revendeur local et transforment chaque événement en spectacle lumineux.",
    venues: ['hôtels et resorts de luxe (Palm, Downtown, Marina)', 'rooftops et beach clubs', 'galas et lancements de marque au DWTC', 'mariages et réceptions privées'],
  },
  {
    slug: 'abu-dhabi',
    name: 'Abu Dhabi',
    country: 'AE',
    region: 'Émirats arabes unis',
    intro:
      "Capitale des Émirats, Abu Dhabi accueille galas officiels, congrès internationaux et grandes réceptions sur Yas Island et la Corniche. Nos bracelets LED synchronisés habillent la foule de lumière, pilotés en direct.",
    venues: ['galas et congrès officiels', 'événements sur Yas Island', 'réceptions sur la Corniche', 'mariages et soirées privées'],
  },
  {
    slug: 'sharjah',
    name: 'Sharjah',
    country: 'AE',
    region: 'Émirats arabes unis',
    intro:
      "Sharjah, cœur culturel des Émirats, reçoit mariages traditionnels, festivals et événements familiaux. Nos kits de bracelets LED apportent une touche lumineuse spectaculaire à vos célébrations.",
    venues: ['mariages et réceptions familiales', 'festivals culturels', 'événements d\'entreprise', 'soirées en bord de lagune'],
  },
  {
    slug: 'ajman',
    name: 'Ajman',
    country: 'AE',
    region: 'Émirats arabes unis',
    intro:
      "Entre resorts de bord de mer et salles de réception, Ajman est une destination prisée pour les mariages et les événements privés. Nos bracelets LED se synchronisent seuls pour illuminer toute l'assemblée.",
    venues: ['resorts et plages privées', 'mariages et réceptions', 'soirées d\'entreprise', 'événements familiaux'],
  },
  {
    slug: 'ras-al-khaimah',
    name: 'Ras Al Khaimah',
    country: 'AE',
    region: 'Émirats arabes unis',
    intro:
      "Ras Al Khaimah, réputée pour ses resorts et son célèbre spectacle du Nouvel An, est une terre d'événements grandioses. Nos kits de bracelets LED synchronisés amplifient chaque moment fort.",
    venues: ['resorts et complexes hôteliers', 'événements du Nouvel An', 'mariages en bord de mer', 'soirées d\'entreprise'],
  },
  {
    slug: 'fujairah',
    name: 'Fujairah',
    country: 'AE',
    region: 'Émirats arabes unis',
    intro:
      "Sur la côte est des Émirats, Fujairah séduit par ses resorts face à l'océan Indien. Nos bracelets LED transforment mariages et réceptions en véritables tableaux lumineux.",
    venues: ['resorts de la côte est', 'mariages face à la mer', 'événements d\'entreprise', 'réceptions privées'],
  },
  {
    slug: 'al-ain',
    name: 'Al Ain',
    country: 'AE',
    region: 'Émirats arabes unis',
    intro:
      "Al Ain, la ville-jardin classée au patrimoine mondial, accueille mariages et réceptions dans un cadre unique. Nos kits de bracelets LED synchronisés y créent une ambiance mémorable.",
    venues: ['mariages et grandes réceptions', 'événements familiaux', 'soirées d\'entreprise', 'festivals locaux'],
  },
];

export const cityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
